import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import EarnItemDetails from './EarnItemDetails';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';

const EarnItemShow = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { findEarnItem, earnItem, isLoading } = useEarnItems();

	const handleEditClick = () => navigate(`/earn-items/${id}/edit`);

	const demoEarnItem = {
		name: 'Earn Item 3',
		item: 'Type C',
		coins: 300,
		xp: 150,
		id: 3
	};

	useEffect(() => {
		if (id) findEarnItem(id);
	}, [id]);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : earnItem?.name}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<EarnItemDetails earnItem={earnItem} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default EarnItemShow;
